"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHotelLineDescriptions = void 0;
const hotel_1 = require("../hotel");
const pluralize_1 = require("../pluralize");
const groupRoomsByTypeAndBoard_1 = require("./groupRoomsByTypeAndBoard");
function getHotelLineDescriptions(config) {
    const descriptions = [];
    const grouped_rooms = (0, groupRoomsByTypeAndBoard_1.groupRoomsByTypeAndBoard)(config.rooms.rooms);
    grouped_rooms.forEach((room) => {
        let occupancy = room.occupancy;
        if (room.extra_beds > 0) {
            occupancy += room.extra_beds;
        }
        descriptions.push({
            title: `${room.quantity} x ${room.name} ${room.extra_beds > 0
                ? ` + ${(0, pluralize_1.pluralize)(room.extra_beds, "extra bed", "extra beds")}`
                : ""} - ${(0, pluralize_1.pluralize)(occupancy, "guest", "guests")}`,
            quantity: room.quantity,
            extras: room.extra_beds > 0
                ? ` + ${(0, pluralize_1.pluralize)(room.extra_beds, "extra bed", "extra beds")}`
                : "",
            room: room,
            occupancy_raw: occupancy,
            occupancy: (0, pluralize_1.pluralize)(occupancy, "guest", "guests"),
        });
    });
    const dinners = (0, hotel_1.getCompulsoryDinnerDescriptions)(config);
    if (dinners && dinners.length > 0) {
        for (const dinner of dinners) {
            descriptions.push(dinner);
        }
    }
    return descriptions;
}
exports.getHotelLineDescriptions = getHotelLineDescriptions;
